import { Image, ResourceItemSimpleList, type ConnectionResourceItemProps } from "@wayflyer/flyui";
import type { BankConnectionSchema, LogoLoadingState } from "@wayflyer/customer-bankconnect";
import type { IntlShape } from "react-intl";
import type { ConnectorPropertiesSchema } from "shared-ui";

import { BankLogoDisplay } from "../../bank-logo-display";
import { COMMON_MESSAGES } from "../../common-messages";

export const connectedBankingDataSourcesItemProps = (
  intl: IntlShape,
  logoLoadingStates: LogoLoadingState,
  bankConnections: BankConnectionSchema[]
): ConnectionResourceItemProps[] => {
  const sources: ConnectionResourceItemProps[] = [];
  bankConnections.forEach((dataSource) => {
    const connectedAccounts = dataSource.accounts.filter((account) => account.pull_enabled);
    sources.push({
      testId: `banking-data-${dataSource.institutionID}`,
      label: `${dataSource.institutionName}`,
      icon: <BankLogoDisplay logoState={logoLoadingStates[dataSource.institutionID]} />,
      status: "positive",
      statusText: intl.formatMessage(COMMON_MESSAGES.connected),
      children: connectedAccounts.length > 0 && (
        <ResourceItemSimpleList
          items={connectedAccounts.map((account) =>
            intl.formatMessage(
              { id: "funding-application: account ending", defaultMessage: "Account ending {mask}" },
              { mask: account.mask }
            )
          )}
        />
      ),
    });
  });
  return sources;
};

export const connectedConnectorResourcesItemProps = (
  intl: IntlShape,
  connectors: ConnectorPropertiesSchema[]
): ConnectionResourceItemProps[] => {
  const completedItems: ConnectionResourceItemProps[] = connectors
    .filter(
      (connector) =>
        // Ensure some connections are connected
        connector.connections.length && connector.connections.some((connection) => connection.isConnected)
    )
    .map((connector) => {
      return {
        testId: `connection-${connector.slug}`,
        label: connector.name,
        icon: connector.connectionLogoSrc ? <Image src={connector.connectionLogoSrc} /> : null,
        status: "positive",
        statusText: intl.formatMessage(COMMON_MESSAGES.connected),
        children: (
          <ResourceItemSimpleList
            items={connector.connections
              .filter((connection) => connection.isConnected) // only shoq connected connections
              .map((connection) => connection.identifierName || connector.name)}
          />
        ),
      };
    });
  return completedItems;
};
